import ScrollToTop from '../components/ScrollToTop'
import Download from '../components/Djado/Download'

export const DjadoDownload = () => {
    return (
        <>
            <ScrollToTop />
            <Download />
        </>
    )
}

export default DjadoDownload
